import { render, staticRenderFns } from "./RejectWalletRequestModal.vue?vue&type=template&id=3e8a1b23&scoped=true"
import script from "./RejectWalletRequestModal.vue?vue&type=script&lang=js"
export * from "./RejectWalletRequestModal.vue?vue&type=script&lang=js"
import style0 from "./RejectWalletRequestModal.vue?vue&type=style&index=0&id=3e8a1b23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8a1b23",
  null
  
)

export default component.exports